{{#> elements/_dt}}
  {{> elements/_label required=true}}
{{/elements/_dt}}

{{#each static_options}}
  <dd class="elligibility elligibility--{{#if data-eligibility}}{{data-eligibility}}{{else}}eligible{{/if}}">
    <input id="{{concat ../index 'elligibility' @key}}" type="radio" name="{{../prefix}}[{{../name}}]" value="{{value}}" required
        {{#if data-eligibility}}data-eligibility="{{data-eligibility}}"{{/if}}
        {{#equal data-eligibility 'ineligible' }}data-eligibility-message="{{../text}}"{{/equal}}
    />
    <label for="{{concat ../index 'elligibility' @key}}">
      {{value}}
    </label>
  </dd>
{{/each}}
